import React, { useEffect, useState } from 'react';
import { Container, Header, SpaceBetween, FormField, Toggle, TokenGroup, Input, Button } from '@cloudscape-design/components-themed/components';
import { getFieldOnChange } from '@/presentation/components';
import { arnPatternType } from '@/presentation/pages/proxies/proxies-types';
const ProxiesFormIAMAuthentication = (props) => {
    var _a, _b, _c, _d;
    const { validation, setIamAccessFormatError } = props;
    const [iamAccessValue, setIamAccessValue] = useState("");
    const [existingIamAccesss, setExistingIamAccesss] = useState(((_b = (_a = props.info) === null || _a === void 0 ? void 0 : _a.details) === null || _b === void 0 ? void 0 : _b.proxyIAMAccess) || []);
    const actionConfigOnChange = getFieldOnChange("tokenGroup", "proxyIAMAccess", props.onChange);
    const [iamAccessError, setIamAccessError] = useState((validation === null || validation === void 0 ? void 0 : validation.iamAccessError) || false);
    const handlePropertyIamAccessFiltersOnChangeToken = (newOptions) => {
        const selectedTokens = (newOptions === null || newOptions === void 0 ? void 0 : newOptions.filter(item => (item.value).trim() !== "")) || [];
        setExistingIamAccesss(selectedTokens);
        actionConfigOnChange(selectedTokens);
        setIamAccessValue('');
    };
    const addIamAccesssToList = (accessValueList) => {
        const tokenGroup = {
            value: accessValueList,
        };
        const updatedIamAccesss = [...existingIamAccesss, tokenGroup];
        const uniqueIdentifier = 'value';
        const uniqueUpdatedIamAccesss = [...new Map(updatedIamAccesss === null || updatedIamAccesss === void 0 ? void 0 : updatedIamAccesss.map(item => [item[uniqueIdentifier], item])).values()];
        handlePropertyIamAccessFiltersOnChangeToken(uniqueUpdatedIamAccesss);
    };
    const removeIamAccesssFromList = (event) => {
        const updatedIamAccesss = [
            ...existingIamAccesss.slice(0, event.detail.itemIndex),
            ...existingIamAccesss.slice(event.detail.itemIndex + 1)
        ];
        handlePropertyIamAccessFiltersOnChangeToken(updatedIamAccesss);
    };
    const toggleAuthCredentials = (event) => {
        var _a, _b;
        props.onChange({
            credentialsAuthEnabled: (_b = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.checked) !== null && _b !== void 0 ? _b : false
        });
    };
    const validateIamAccess = (val) => {
        const trimmedValue = val.trim();
        if (trimmedValue === "")
            return false;
        const isInvalid = !arnPatternType.test(trimmedValue);
        setIamAccessError(isInvalid);
        setIamAccessFormatError(isInvalid);
        return !isInvalid;
    };
    const validatedOnIamAccessOnEnter = () => {
        if (validateIamAccess(iamAccessValue)) {
            addIamAccesssToList(iamAccessValue);
        }
    };
    useEffect(() => {
        setIamAccessError(validation.iamAccessError);
    }, [validation.iamAccessError]);
    return React.createElement("div", { className: "multi-select-container" },
        React.createElement(Container, { header: React.createElement(Header, { variant: "h2" }, "Proxy Authentication") },
            React.createElement(SpaceBetween, { size: 's' },
                React.createElement(FormField, { label: "Client Credentials Auth", description: "Allow the proxy to authenticate to the Kivera control plane using client credentials. Disabling this will also disable any client credentials that are currently active for this proxy." },
                    React.createElement(Toggle, { onChange: toggleAuthCredentials, checked: (_d = (_c = props === null || props === void 0 ? void 0 : props.info) === null || _c === void 0 ? void 0 : _c.details) === null || _d === void 0 ? void 0 : _d.credentialsAuthEnabled })),
                React.createElement(SpaceBetween, { size: "xxxs" },
                    React.createElement(FormField, { label: "AWS IAM Role Auth (ARN)", description: "Allow the proxy to authenticate to the Kivera control plane by assuming one of the specified AWS IAM roles", errorText: iamAccessError ? "Please enter a valid ARN" : "" },
                        React.createElement("div", { className: "flex flex-wrap justify-between" },
                            React.createElement("div", { className: "w-4/6 grow mr-4" },
                                React.createElement(Input, { placeholder: "Enter ARN", "data-dd-privacy": "mask", "data-dd-action-name": "ARN Input", value: iamAccessValue, onChange: ({ detail }) => {
                                        setIamAccessError(false);
                                        setIamAccessFormatError(false);
                                        setIamAccessValue(detail.value);
                                    }, onKeyUp: ({ detail }) => {
                                        if (detail.keyCode === 13) {
                                            validatedOnIamAccessOnEnter();
                                        }
                                    } })),
                            React.createElement("div", null,
                                React.createElement(Button, { variant: "normal", disabled: iamAccessValue === '' || iamAccessError, onClick: () => validatedOnIamAccessOnEnter() }, "Add")))),
                    React.createElement("div", { className: 'mt-[-2px]' },
                        React.createElement(TokenGroup, { alignment: "vertical", "data-dd-privacy": "mask", items: existingIamAccesss, onDismiss: removeIamAccesssFromList }))))));
};
export default ProxiesFormIAMAuthentication;
